
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Capturador global de erros síncronos
window.addEventListener('error', (event) => {
  console.error('[global error]', event.message, event.error);
});

// Capturador global de promessas rejeitadas não tratadas
window.addEventListener('unhandledrejection', (event) => {
  console.error('[unhandledrejection]', event.reason);
});

// Instrumentação para detecção de reloads por troca de aba
if (typeof window !== 'undefined' && localStorage.getItem('DEBUG_FOCUS_RELOAD') === '1') {
  const log = (...args: any[]) => console.log('%c[FocusReload]', 'color: #0084ff; font-weight: bold;', ...args);
  
  log('Sessão iniciada em:', new Date().toLocaleTimeString());
  
  window.addEventListener('visibilitychange', () => {
    log('Visibility Changed:', document.visibilityState);
  });
  
  window.addEventListener('focus', () => log('Window Focus gained'));
  window.addEventListener('blur', () => log('Window Focus lost'));
  
  window.addEventListener('beforeunload', (e) => {
    log('Página sendo descarregada (reload/close)');
  });

  const [navigation] = performance.getEntriesByType('navigation') as any[];
  if (navigation) {
    log('Navigation Type:', navigation.type, '(reload, navigate, back_forward)');
  }
}

// Log de inicialização para verificar ambiente
console.log('[boot] app starting', {
  href: location.href,
  origin: location.origin,
  pathname: location.pathname,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
// Removido StrictMode para estabilizar a inicialização em sandboxes de navegador
root.render(<App />);
